module.exports = __webpack_public_path__ + "01_bob_black.491bffce.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/girl/layer5/01_bob_black.png
// module id = QDx8
// module chunks = 0